/* Soul On Sky: gentle 3D effects (scroll reveal and hover tilt). Skipped for reduced motion and in the theme editor. */
(function () {
  'use strict';

  if (window.Shopify && window.Shopify.designMode) return;
  if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  var finePointer = window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches;

  /* 1. Scroll reveal: sections rise and turn into place as they enter the screen */
  if ('IntersectionObserver' in window) {
    var revealSelector = [
      '.how-order__inner',
      '.craft__head',
      '.craft-step',
      '.artisans__inner',
      '.dyp-banner__inner',
      '.biz-banner__inner',
      '.dyp__inner',
      '.bwu__head',
      '.bwu__who',
      '.bwu__why',
      '.bwu__how',
      '.bwu__form'
    ].join(',');

    var nodes = Array.prototype.slice.call(document.querySelectorAll(revealSelector));

    var onHome = location.pathname === '/' || location.pathname === '';
    if (onHome) {
      nodes = nodes.concat(Array.prototype.slice.call(document.querySelectorAll('#MainContent > .shopify-section:not(:first-child)')));
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('sos-in');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.12, rootMargin: '0px 0px -6% 0px' }
    );

    nodes.forEach(function (node) {
      node.classList.add('sos-reveal');
      observer.observe(node);
    });
  }

  /* 2. Hover tilt for cards and buttons (mouse only, never on touch screens) */
  if (finePointer) {
    var BUTTONS = '.button, .button-secondary, .button-custom, .sos-gold-btn';
    var CARDS = [
      '.product-card__content',
      '.how-order__step',
      '.bwu__card',
      '.bwu__benefits li',
      '.bwu__steps li',
      '.dyp__how li',
      '.craft-step__media',
      '.artisans__media',
      '.collection-card'
    ].join(', ');
    var ALL = BUTTONS + ', ' + CARDS;

    var current = null;
    var frame = 0;

    var reset = function (element) {
      if (!element) return;
      element.style.setProperty('--sos-rx', '0deg');
      element.style.setProperty('--sos-ry', '0deg');
    };

    document.addEventListener(
      'pointermove',
      function (event) {
        if (event.pointerType && event.pointerType !== 'mouse') return;

        var target = event.target && event.target.closest ? event.target.closest(ALL) : null;
        if (current && current !== target) reset(current);
        current = target;
        if (!target) return;

        var isButton = target.matches(BUTTONS);
        if (!isButton && !target.classList.contains('sos-tilt')) {
          target.classList.add('sos-tilt');
        }

        var x = event.clientX;
        var y = event.clientY;
        if (frame) cancelAnimationFrame(frame);
        frame = requestAnimationFrame(function () {
          var rect = target.getBoundingClientRect();
          if (!rect.width || !rect.height) return;
          var max = isButton ? (rect.width > 300 ? 2 : 5) : rect.width > 500 ? 4 : 7;
          var px = (x - rect.left) / rect.width - 0.5;
          var py = (y - rect.top) / rect.height - 0.5;
          target.style.setProperty('--sos-ry', (px * max * 2).toFixed(2) + 'deg');
          target.style.setProperty('--sos-rx', (-py * max * 2).toFixed(2) + 'deg');
        });
      },
      { passive: true }
    );

    document.addEventListener('mouseout', function (event) {
      if (!event.relatedTarget) {
        reset(current);
        current = null;
      }
    });
  }
})();
